import React from 'react'
import AddSubscription from './AddSubscription'
import { ChildrenProps } from '../../types'
import ContentHeader from '../../../components/layout/ContentHeader'
import HeaderActions from '../../../components/layout/HeaderActions'
import HeaderTitle from '../../../components/layout/HeaderTitle'

function MessageBox(props: ChildrenProps) {
  return (
    <ContentHeader>
      <HeaderTitle>
        {props.children}
      </HeaderTitle>
      <HeaderActions>
        <AddSubscription />
      </HeaderActions>
    </ContentHeader>
  )
}

export default MessageBox
